// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Finances20 from './Finances20';
import Finances24 from './Finances24';

type FinancesProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Finances20,
    Finances24,
};

const Finances: FC<FinancesProps> = ({ variation, ...props }) => {
    const variationKey = `Finances${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Finances" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Finances;
